/**
 * Initialize dynamic aria-current="page" for header links on client side to avoid issues with cached header HTML.
 */
export function initializeAriaCurrent() {
  try {
    const headerRoot = document.getElementById('js-header') || document;

    const normalizePath = (path) => {
      if (!path) {
        return '/';
      }
      // Ensure leading slash, collapse multiple slashes, remove trailing slash (except root)
      let p = path;
      if (!p.startsWith('/')) p = '/' + p;
      p = p.replace(/\/{2,}/g, '/');
      if (p !== '/') p = p.replace(/\/$/, '');
      return p;
    };

    const isCurrentPathInclusive = (targetUrl) => {
      if (!targetUrl) {
        return false;
      }

      // Skip anchors and non-HTTP(S) links
      const raw = String(targetUrl).trim();
      if (raw.startsWith('#') || raw.startsWith('mailto:') || raw.startsWith('tel:') || raw.startsWith('javascript:')) {
        return false;
      }

      let targetPath = '/';
      try {
        const u = new URL(raw, window.location.origin);
        targetPath = u.pathname || '/';
      } catch (_) {
        // Fallback for weird relative values
        targetPath = raw;
      }

      // Handle special strings like 'home' or empty
      if (targetPath === '' || targetPath === 'home') {
        targetPath = '/';
      }

      const currentPath = normalizePath(window.location.pathname || '/');
      targetPath = normalizePath(targetPath);

      // Inclusive match (like PHP implementation)
      if (currentPath === targetPath) {
        return true;
      }
      if (targetPath === '/') {
        return currentPath === '/';
      }
      return currentPath.startsWith((targetPath.endsWith('/') ? targetPath.slice(0, -1) : targetPath) + '/');
    };

    const apply = () => {
      // Limit to header to avoid impacting breadcrumbs or other components
      const links = headerRoot.querySelectorAll('a[href]');
      links.forEach((a) => {
        // Only process elements that either already have aria-current or explicitly opt-in via data-aria-current-candidate
        // If none opt-in attribute is present, process all header links (safe default for our header use-case)
        const href = a.getAttribute('href') || '';
        const matches = isCurrentPathInclusive(href);
        if (matches) {
          a.setAttribute('aria-current', 'page');
        } else {
          // Remove to avoid stale state from cached HTML
          if (a.hasAttribute('aria-current')) {
            a.removeAttribute('aria-current');
          }
        }
      });
    };

    // Initial application
    apply();

    // Re-apply on history navigation (SPA-like back/forward) and hash changes
    window.addEventListener('popstate', apply);
    window.addEventListener('hashchange', apply);
  } catch (e) {
    // Fail silently to avoid breaking header in edge cases
    // console.warn('initializeAriaCurrent failed', e);
  }
}
